module.exports = {
	"LANGUAGE": "語言",
	"HDR-obpa_fulltext_score": "評分",
	"HDR-obpa_name": "名稱",
	"HDR-obpa_fulltext_summary": "摘要",
	"QUERY LIMIT REACHED": "結果比顯示的結果多。請縮小搜索條件範圍。",
	"NO DOCUMENTS FOUND": "沒有找到文件。",
	"OPEN IN NEW WINDOW": "在新窗口中打開",
	"DOWNLOAD NATIVE": "以原生格式下載",
	"CLOSE": "關閉",
	"SEARCH TYPE": "搜尋類型",
	"DOCUMENT TYPE": "文檔類型",
	"SEARCH TERM": "搜索詞",
	"SEARCH": "搜尋",
	"RESET": "重置",
	"DATE": "日期",
	"FROM DATE": "開始日期",
	"TO DATE": "結束日期",
	"LOADING": "載入中...",
	"RETRY": "重試",
	"ERROR": "錯誤！",
	"ERROR: QUERIES": "無法檢索搜索類型列表。",
	"ERROR: DOCTYPES": "無法檢索文檔類型列表。",
	"ERROR: KEYWORDS": "無法檢索搜索字段列表。",
	"ERROR: DOCUMENTS": "無法執行請求的搜索。",
	"FORM: INVALID FULLTEXT": "字段必須至少為 {{chars}} 個字符。",
	"FORM: INVALID DATE SHORT": "格式: {{format}} .",
	"FORM: REQUIRED KEYWORD": "現場是必需的。",
	"FORM: INVALID NUMERIC": "字段必須是最多 {{digits}} 位數。",
	"FORM: INVALID DATE": "字段必須遵循格式 {{format}} .",
	"FORM: INVALID CURRENCY": "字段必須是有效的貨幣值。",
	"FORM: INVALID FLOAT": "字段必須是數字。",
	"FORM: INVALID LENGTH": "字段必須最多為 {{chars}} 個字符。",
	"FORM: ERRORS": "表單上有錯誤。",
	"FORM: noDate": "必須指定日期範圍。",
	"FORM: noKeyword": "必須至少指定一個字段。",
	"FORM: noDateOrKeyword": "日期範圍或必須至少指定一個字段。",
	"FORM: noDateAndKeyword": "日期範圍AND必須至少指定一個字段。"
};


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/i18n/json/zh-tw.json
// module id = 362
// module chunks = 0